import React from 'react'

const ALLOWED_TAGS = ['b', 'i', 'u', 'strong', 'em']

const TAG_PATTERN = new RegExp(
    `(<(?:${ALLOWED_TAGS.join('|')})>|<\\/(?:${ALLOWED_TAGS.join('|')})>)`,
    'gi'
)

/**
 * Parses a string that may contain simple HTML formatting tags (b, i, u, strong, em)
 * and returns React elements. All other HTML is treated as plain text.
 *
 * Returns the original string unchanged when no formatting tags are present.
 */
export default function renderFormattedText(text) {
    if (!text || typeof text !== 'string') return text || ''
    if (text.indexOf('<') === -1) return text

    const tokens = text.split(TAG_PATTERN)
    if (tokens.length === 1) return text

    let key = 0
    const root = { tag: null, children: [] }
    const stack = [root]

    for (const token of tokens) {
        const openMatch = token.match(/^<(\w+)>$/i)
        const closeMatch = token.match(/^<\/(\w+)>$/i)

        if (openMatch && ALLOWED_TAGS.includes(openMatch[1].toLowerCase())) {
            const node = { tag: openMatch[1].toLowerCase(), children: [] }
            stack[stack.length - 1].children.push(node)
            stack.push(node)
        } else if (closeMatch && ALLOWED_TAGS.includes(closeMatch[1].toLowerCase())) {
            const tagName = closeMatch[1].toLowerCase()
            for (let i = stack.length - 1; i > 0; i--) {
                if (stack[i].tag === tagName) {
                    stack.length = i
                    break
                }
            }
        } else if (token) {
            stack[stack.length - 1].children.push(token)
        }
    }

    function toReact(node) {
        if (typeof node === 'string') return node
        const children = node.children.map(toReact)
        if (node.tag) {
            return React.createElement(node.tag, { key: key++ }, ...children)
        }
        return children
    }

    const result = toReact(root)
    return Array.isArray(result) && result.length === 1 ? result[0] : result
}
